<template>
  <div id="loginPage" class="login">
    <!--<Row type="flex" justify="center">-->
      <!--<Col span="10" class="kuang">-->
        <!--<Row span="24">-->
          <!--<h3>用户登录</h3>-->
        <!--</Row>-->
        <!--<Form ref="formInline" :model="formInline" :rules="ruleInline" inline>-->
          <!--<Row>-->
            <!--<FormItem class="longType" prop="user">-->
              <!--<Input type="text" v-model="formInline.user" placeholder="请输入用户名">-->
              <!--</Input>-->
            <!--</FormItem>-->
          <!--</Row>-->
          <!--<Row>-->
            <!--<FormItem class="longType" prop="password">-->
              <!--<Input type="password" v-model="formInline.password" placeholder="请输入密码">-->
              <!--</Input>-->
            <!--</FormItem>-->
          <!--</Row>-->
          <!--<Row>-->
            <!--<FormItem class="longType" prop="code">-->
              <!--<Col span="10">-->
                <!--<Input type="text" v-model="formInline.code" placeholder="请输入验证码">-->
                <!--</Input>-->
              <!--</Col>-->
              <!--<Col offset="6" span="8">-->
                <!--<img class="codeImg" :src="imgUrl" >-->
              <!--</Col>-->
            <!--</FormItem>-->
          <!--</Row>-->
          <!--<Row>-->
            <!--<FormItem class="longType">-->
              <!--<Button class="loginButton" type="primary" @click="handleSubmit(formInline)">登录</Button>-->
            <!--</FormItem>-->
          <!--</Row>-->
        <!--</Form>-->
      <!--</Col>-->
    <!--</Row>-->
    <div class="logo">
      <div class="logo_title"></div>
      <span style="display: inline-block;font-size: 50px;color: #0089e1">JM内务管理</span>
    </div>
    <div class="loginContainer">
      <!--<Col span="4" class="kuang">-->
      <Row span="24">
        <div class="loginLogo"></div>
      </Row>
      <Form ref="formInline" :model="formInline" class="login_form" :rules="login_validate_Rules" inline>
        <div>
          <FormItem class="longType" prop="user">
            <Input type="text" v-model="formInline.user" placeholder="请输入用户名">
            <icon type="person" slot="prepend"></icon>
            </Input>
          </FormItem>
        </div>
        <div>
          <FormItem class="longType" prop="password">
            <Input type="password" v-model="formInline.password" placeholder="请输入密码">
            <Icon type="ios-locked" slot="prepend"></Icon>
            </Input>
          </FormItem>
        </div>
        <div class="longType ivu-form-item">
            <Col span="10">
            <FormItem  prop="code">
            <Input type="text" v-model="formInline.code" @on-enter="handleSubmit('formInline')" placeholder="请输入验证码">
            </Input>
            </FormItem>
            </Col>
            <Col offset="2" span="8">
            <!--<img class="codeImg" :src="imgUrl" >-->
            <div class="code_container" @click="createCode()">
              <div class="code_img" title="看不清，换一张">{{code}}</div>
              <span class="change_code">&nbsp;换一张</span>
            </div>
            </Col>

        </div>
        <div>
          <FormItem class="longType">
            <Button class="loginButton" type="primary" @click="handleSubmit('formInline')">登录</Button>
          </FormItem>
        </div>
      </Form>
      <!--</Col>-->
    </div>

  </div>
</template>

<script>
import Bus from 'assets/../global/bus.js';
import { mapState, mapGetters, mapMutations } from "vuex";
export default {
  computed: {
    ...mapState(["user", "department", "token"]),
    ...mapGetters(["filterUser"])
  },
  data() {
      const reEXP = /^[A-Za-z0-9]+$/ ;
      const validate_username = (rule,value,callback) =>{
          if(value === ''){
              callback(new Error('请输入用户名！'))
          }else if(!reEXP.test(value)){
              callback(new Error('用户名只能包含字母和数字！'))
          }else {
              callback();
          }
      };
      const validate_pwd = (rule,value,callback) =>{
          if(value ===''){
              callback(new Error('请输入密码！'))
          }else {
              callback();
          }
      }
      const validate_code = (rule,value,callback) =>{
          if(value ==='') {
              callback(new Error('请输入验证码！'));
          }else if(value.toLowerCase() != this.code.toLowerCase()) {
              callback(new Error('验证码错误！'))
          }else {
              callback();
          }
      }
    return {
      formInline: {
        user: "",
        password: "",
        code: ""
      },
        code:'',
      imgUrl: require("assets/logo.png"),
        login_validate_Rules: {
        user: [
//          {
//            required: true,
//            message: "请输入用户名",
//            trigger: "blur"
//          }
            {validator: validate_username,trigger:'blur'}
        ],
        password: [
//          {
//            required: true,
//            message: "请输入密码",
//            trigger: "blur"
//          }
            {validator: validate_pwd,trigger:'blur'}
        ],
        code: [
//          {
//            required: true,
//            message: "请输入验证码",
//            trigger: "blur"
//          }
            {validator: validate_code,trigger:'blur'}
        ]
      }
    };
  },
  components: {
  },
  methods: {
    handleSubmit(row) {
        var that = this;
        console.log(row);
        this.$refs[row].validate((valid) =>  {
          if(valid){
              var params = {
                  data: {
                      "username" :that.formInline.user,
                      "password" :that.formInline.password
                  },
                  url: '/sys/userinfo/login',
                  success: (res) => {
                      console.log(res);
                      if(res.data.code == '0000'){
                        this.$Message.success({
                          content: res.data.message
                        });
                        let roles=res.data.result.roles
                        this.SET_USER(res.data.result.username);
                        this.SET_TOKEN(res.data.result.token);
                        window.localStorage.setItem("userName", res.data.result.username);
                        window.localStorage.setItem("token", res.data.result.token);
                        window.localStorage.setItem("realname", res.data.result.realname);
                        window.localStorage.setItem("_id", res.data.result._id);
                        if(res.data.result.username=='zhoujh'){
                          this.$router.push('data/asetsList')
                        }else if(res.data.result.username=='zhongyf'){
                          this.$router.push('data/dinnerState')
                        }else if(res.data.result.username=='admin'){
                          this.$router.push('data/dinnerState')
                        }else{
                          roles.map(item=>{
                            console.log(item);
                            if(item.rolename==='系统管理员'){
                              console.log(777777);
                              console.log(item.rolename);
                              that.$router.push('data/dinnerState')
                            }
                            return
                          })
//                          this.$router.push('data/')
                        }
                      }else{
                          this.$Message.warning({
                              content: res.data.message
                          })
                      }
                  }
              }
              this.ajaxPost(params)
          }else {
              this.$Message.error('验证码错误');
          }
      })

    },
      //生成二维码
      createCode: function () {
          console.log(7777);
          this.code = "";
          let codeLength = 4; //验证码的长度
          let codeChars = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9,
              'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
              'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'); //所有候选组成验证码的字符，当然也可以用中文的
          for (var i = 0; i < codeLength; i++) {
              var charNum = Math.floor(Math.random() * 60);
              this.code += codeChars[charNum];
          }
      },
    ...mapMutations(["SET_USER","SET_TOKEN","SET_DEPART"])
  },
    mounted(){
        this.createCode();
    },
};
</script>

<style lang="scss" scoped>
h3{
  font-size: 30px;
  line-height: 50px;
  height: 50px;
}
.login{
  /*text-align: center;*/
  position: relative;
  height: 100vh;
  /*background: url("../../assets/login/timg-7.jpeg");*/
  background-size: cover;
  .logo {
    padding-top: 35px;
    width:100%;
  .logo_title {
    background: url("../../assets/login/logo_left.png");
    width: 155px;
    height: 154px;
    display: inline-block;
    vertical-align: middle;
    /*margin: 0 auto;*/
    /*position: relative;*/
    /*top:80px;*/
    /*top: 20px;*/
  }
  }
  .loginContainer{
    text-align: center;
    width: 400px;
    margin-top: 30px;
    position: absolute;
    background-color: #fff;
    border-radius: 10px;
    /*border: 1px solid #000;*/
    filter:progid:DXImageTransform.Microsoft.Shadow(color=#909090,direction=120,strength=4);/*ie*/
    -moz-box-shadow: 2px 2px 10px #909090;/*firefox*/
    -webkit-box-shadow: 2px 2px 10px #909090;/*safari或chrome*/
    box-shadow:2px 2px 10px #909090;/*opera或ie9*/
    right: 10vh;
    .loginLogo{
      background: url("../../assets/login/logo_right.png");
      width: 142px;
      height: 142px;
      margin: 5px auto;
    }
    .code_container {
      cursor: pointer;
    /*display: inline;*/
      .code_img {
        width: 145px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 30px;
        display: inline-block;
        border: 1px solid #75bdff;
        margin-left: 11%;
        letter-spacing: 10px;
        font-weight: bold;
        font-style: italic;
        color: blue;
      }
      .change_code {
        font-size: 15px;
      }
      .change_code:hover {
        color: rgb(64, 176, 255);
      }
    }
  }
  .longType {
    width: 80%;
    .loginButton{
      width: 100%;
    }
  }
  /*.login_form{*/
    /*.ivu-form-item {*/
      /*margin-left: -20px;*/
      /*height: 40px;*/
      /*line-height: 40px;*/
    /*!*.ivu-form-item-label:before{*!*/
    /*!*content: '';*!*/
    /*!*margin-right: 0px;*!*/

    /*!*}*!*/
    /*.ivu-input {*/
      /*height: 40px;*/
      /*width: 300px;*/
      /*padding-left: 30px;*/
    /*}*/
    /*.ivu-input-icon {*/
      /*font-size: 25px;*/
      /*height: 40px;*/
      /*line-height: 40px;*/
      /*left: 0;*/
      /*!*background-color: skyblue;*!*/
      /*}*/

    /*}*/

  /*}*/

}
.kuang {
  border: 2px solid black;
  border-radius: 10px;
  padding: 20px 0;
}

.loginButtonP {
  width: 100%;
}
.codeImg{
  width: 100%;
  height: 100%;
  max-height: 28px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue